import React, { useEffect, useState } from 'react';

export const HeroBlockImage = ({leftHeader, leftContent, image}) => {

    return (
        <div className="container my-5">
            <div className="row p-4 pb-0 pe-lg-0 pt-lg-5 align-items-center rounded-3 border shadow-lg">
                <div className="col-lg-7 p-3 p-lg-5 pt-lg-3">
                    <h1 className="display-4 fw-bold lh-1">{leftHeader}</h1>
                    <div className="lead mb-3">{leftContent}</div>
                </div>
                <div className="col-lg-4 offset-lg-1 p-0 overflow-hidden shadow-lg">
                    <img src={image} alt=""/>
                </div>
            </div>
        </div>
    );

}

export const HeroCentered = ({title, content, image}) => {

    return (
        <div className="px-4 pt-5 my-5 text-center border-bottom">
            <h1 className="display-4 fw-bold">{title}</h1>
            <div className="col-lg-6 mx-auto">
                <p className="lead mb-4">{content}</p>
            </div>
            <div className="overflow-hidden" style={{ maxHeight: "30vh" }}>
                <div className="container px-5">
                    <img src={image} alt=""/>
                </div>
            </div>
        </div>
    );

}

export const HeroSplitDefault = ({ leftHeader, leftContent, rightContent }) => {

    return (
        <div className="container col-xl-10 col-xxl-8 px-4 py-5">
            <div className="row align-items-center g-lg-5 py-5">
                <div className="col-md-5 col-lg-7 text-center text-lg-start">
                    <div className="pt-3">
                        <h1 className="display-4 fw-bold lh-1 mb-3">{leftHeader}</h1>
                        <div className="lead pt-4">{leftContent}</div>
                    </div>
                </div>
                <div className="col-md-7 col-lg-5 mx-auto">
                    {rightContent}
                </div>
            </div>
        </div>
    );

}

export const HeroDefault = ({ header, content }) => {

    return (
        <div className="container col-xl-10 col-xxl-8 px-4">
            <div className="row align-items-center g-lg-5">
                <div className="text-center text-lg-start">
                    <div className="pt-3">
                        <h1 className="display-4 fw-bold lh-1 mb-3">{header}</h1>
                        <div className="lead pt-4">{content}</div>
                    </div>
                </div>
            </div>
        </div>
    );

}

export const HeroSplitImage = ({imagePosition, image, header, content}) => {

    const [sectionStyle, setSectionStyle] = useState("-reverse");

    useEffect(() => {
        imagePosition === 'left' ? (setSectionStyle("-reverse")) : (setSectionStyle(""))
    },[imagePosition])


    return (
        <div className="container col-xxl-8 px-4 py-5">
            <div className={"row flex-lg-row" + sectionStyle + " align-items-center g-5 py-5"}>
                <div className="col-10 col-sm-8 col-lg-6">
                    <img src={image} alt=""/>
                </div>
                <div className="col-lg-6">
                    <h1 className="display-5 fw-bold lh-1 mb-3">{header}</h1>
                    <p>
                        {content}
                    </p>
                </div>
            </div>
        </div>
    );

}


